import { render, staticRenderFns } from "./LiveComment.vue?vue&type=template&id=d79ef458&scoped=true&"
import script from "./LiveComment.vue?vue&type=script&lang=ts&"
export * from "./LiveComment.vue?vue&type=script&lang=ts&"
import style0 from "./LiveComment.vue?vue&type=style&index=0&id=d79ef458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79ef458",
  null
  
)

export default component.exports